import React, { useState } from 'react';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import ValueDetailsRow from '../../components/ValueDetailsRow';
import ExtraFields from '../../components/ExtraFields';
import { SummaryRow } from '../../components/SummaryRow';
import Observation from '../../components/Observation';

export default function ShipmentTransferShow() {
  const {
    shipmentTransferExtraFields,
    totalShipmentTransfer,
    transferTags,
    tollValue,
    transferFerryValue,
    transferChargeValue,
    transferDischargeValue,
    transferTollValue,
    shouldUseTransferToll,
    shouldUseTransferDischarge,
    shouldUseTransferCharge,
    shouldUseTransferFerry,
    pcpObservation,
    negotiatorObservation,
  } = useFreightValues();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Repasse ao transportador"
        isOpen={isOpen}
        onToggleCard={() => setIsOpen(!isOpen)}
        tooltipContent="Valores a serem repassados ao transportador conforme itens definidos, não contempla taxa administrativa sobre o valor."
        totalsSection={
          <HeaderTotalSummary
            label="Valor Crédito"
            totalInReal={totalShipmentTransfer?.total}
            totalInDollar={totalShipmentTransfer?.totalDollarValue}
          />
        }
        hasTagsRow
        tagsContent={transferTags}
      />
      {isOpen && (
        <>
          {shouldUseTransferToll > 0 && (
            <ValueDetailsRow
              label="Pedágio"
              value={transferTollValue?.value}
              dollarValue={transferTollValue?.dollarValue}
              obs={tollValue?.action?.name}
            />
          )}
          {shouldUseTransferDischarge > 0 && (
            <ValueDetailsRow
              label="Descarga"
              value={transferDischargeValue?.value}
              dollarValue={transferDischargeValue?.dollarValue}
            />
          )}
          {shouldUseTransferCharge && (
            <ValueDetailsRow
              label="Taxa de carregamento"
              value={transferChargeValue?.value}
              dollarValue={transferChargeValue?.dollarValue}
            />
          )}
          {shouldUseTransferFerry && (
            <ValueDetailsRow
              label="Balsa"
              value={transferFerryValue?.value}
              dollarValue={transferFerryValue?.dollarValue}
            />
          )}
          {shipmentTransferExtraFields?.length > 0 ? (
            <>
              <Text type="regular" weight={500}>
                Valores extras
              </Text>
              <ExtraFields show fields={shipmentTransferExtraFields} />
            </>
          ) : null}
          <SummaryRow
            label="Valor Crédito"
            totalInReal={totalShipmentTransfer?.total}
            totalInDollar={totalShipmentTransfer?.totalDollarValue}
            id="valor-crédito"
          />
          <Observation label="Observações PCP" value={pcpObservation} />
          <Observation label="Observações Negociador" value={negotiatorObservation} />
        </>
      )}
    </Card>
  );
}
